//Reset data
export const RESET = "AGENT_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "AGENT_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "AGENT_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "AGENT_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "AGENT_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "AGENT_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "AGENT_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "AGENT_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "AGENT_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "AGENT_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "AGENT_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "AGENT_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "AGENT_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "AGENT_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "AGENT_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "AGENT_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "AGENT_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "AGENT_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "AGENT_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "AGENT_LIST_SET_MODAL_TYPE"